<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card class="" elevation="" max-width="">
                    <v-card-title class="justify-center"> Lista de Tokens de Clientes </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <!-- Filtros de busqueda -->
                        <v-row>
                            <!-- <v-col cols="12" md="2">
                                <v-select
                                    :items="resources.tipoAutenticacion"
                                    label="Tipo de Autenticación"
                                    v-model="filtros.tipo_autenticacion"
                                    @change="getData"
                                ></v-select>
                            </v-col> -->

                            <v-col cols="12" md="10">
                                 <v-text-field
                                    label="Buscar por nombre"
                                    v-model="filtros.search"
                                    @input="getData"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" class="d-flex align-center gap-2">
                                <v-btn color="primary" @click="getData">Buscar</v-btn>
                                <v-btn color="secondary" @click="resetFilters">Limpiar</v-btn>
                            </v-col>
                        </v-row>


                        <v-data-table
                            :headers="table.headers"
                            :items="usuarios.data"
                            :items-per-page="filtros.per_page"
                            class="elevation-1"
                            :options.sync="table.options"
                            :server-items-length="usuarios.total"
                            @update:options="changeOptionsTable"
                            :loading="table.loader"
                        >

                            <template v-slot:item.cliente_nombre="{ item }">
                                <span v-if="item.cliente_nombre">{{ item.cliente_nombre }}</span>
                                <span v-else>N/A</span>
                            </template>

                            <template v-slot:item.idtipo_documento_identidad="{ item }">
                                <span v-if="item.tipo_documento">{{ item.tipo_documento.nombre.toUpperCase() }}</span>
                                <span v-else>N/A</span>
                            </template>



                            <template v-slot:item.url_definir_clave="{ item }">
                                <div v-if="item.url_definir_clave" >
                                    <v-text-field
                                        :value="item.url_definir_clave"
                                        readonly
                                        dense
                                        hide-details
                                        outlined
                                        class="flex-grow-1"
                                        :append-outer-icon="copiedId === item.codigo ? 'mdi-check' : 'mdi-content-copy'"
                                        @click:append-outer="copyUrl(item)"
                                    ></v-text-field>
                                </div>

                                <span v-else>N/A</span>
                            </template>

                        </v-data-table>


                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script >
    import axios from '@/plugins/axios';

    const clientesSinClavesService = {
        paginacion(filtros) {
            return axios.get('/api/panel/clientes/sin-clave', { params: filtros });
        },


    }


    export default {
        name: "GoogleList",
        data() {
            return {
                resources: {
                    cantidadRegistros: [
                        { text: '15', value: 15 },
                        { text: '25', value: 25 },
                        { text: '50', value: 50 },
                        { text: '100', value: 100 }
                    ],
                },
                table: {
                    headers: [
                        { text: 'Codigo', value: 'codigo' },
                        { text: 'Cliente', value: 'cliente_nombre' },
                        { text: 'Correo', value: 'correo' },
                        { text: 'Telefono', value: 'telefono' },
                        { text: 'T. Doc', value: 'idtipo_documento_identidad' },
                        { text: 'N. Doc', value: 'numero_documento_identidad' },
                        { text: 'Token', value: 'token_para_definir_clave', sortable: false },
                        { text: 'Acciones', value: 'url_definir_clave', sortable: false },
                    ],
                    options: {},
                    loader: false,

                },
                filtros: {
                    search: '',
                    per_page: 15,
                    idtipo_documento_identidad: null
                },
                usuarios: [],
                copiedId: null

            }
        },
        methods: {
            async getData({
                page = 1,
                perPage = 15,
                sortBy = null,
                sortDesc = null,
            } = '') {

                this.table.loader = true;

                try {
                    const res = await clientesSinClavesService.paginacion({
                        page: page,
                        per_page: perPage,
                        search: this.filtros.search,
                        sort_by: sortBy,
                        sort_desc: sortDesc !== null ? (sortDesc ? 'desc' : 'asc') : null,
                    });
                    this.usuarios = res.data;
                } catch (error) {
                    console.error(error);
                    this.$toasted.error('Error al cargar los datos de los clientes sin clave');
                } finally {
                    this.table.loader = false;
                }
            },

            changeOptionsTable(options) {
                this.getData({
                    page: options.page,
                    perPage: options.itemsPerPage,
                    sortBy: options.sortBy.length > 0 ? options.sortBy[0] : null,
                    sortDesc: options.sortDesc.length > 0 ? options.sortDesc[0] : null,
                });
            },

            resetFilters() {
                this.filtros.search = '';
                this.table.options.page = 1;
                this.table.options.itemsPerPage = 15;
                this.table.options.sortBy = [];
                this.table.options.sortDesc = [];
                this.getData();
            },

            copyUrl(item) {
                const url = item.url_definir_clave;

                navigator.clipboard
                    .writeText(url)
                    .then(() => {
                        this.copiedId = item.codigo;
                        setTimeout(() => {
                            this.copiedId = null;
                        }, 2000);

                        this.$toasted.success('URL copiada al portapapeles',{
                            icon: 'mdi-check-bold',
                        });

                    }).catch(err => {
                        console.error('Error al copiar al portapapeles: ', err);
                    });
            }
        }
    }
</script>

<style scoped>
    .gap-2 {
        gap: 8px;
    }
</style>